collectionProductSetUp = function(isSearch) {
  function toggleLayout() {
    $('[data-left-col-toggle] .collection-toggle-show-label, [data-left-col-toggle] .collection-toggle-hide-label').toggleClass("hide");

    $(".page-split-container").toggleClass("hide-column-left");
    $("[data-toggle=page-split--mobile-left-slide-out]").toggleClass("show");
  }

  function toggleSortBy() {
    $(".sort-by-mobile-popout").toggleClass("show");
    $(".sort-by-mobile-popout").siblings(".page-split-overlay").toggleClass("show");
  }

  function clearProductItemHeight() {
    $(".product-grid-item").each(function() {
      $(this).removeAttr("style");
    })
  }

  function setProductItemHeight() {
    $(".product-grid-item").each(function() {
      $(this).css("height", $(this).height() + 'px');
    })
  }

  function productHeightListener() {
    setProductItemHeight();

    $(window).resize(function() {
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function(){
          clearProductItemHeight();
          setProductItemHeight();
        }, 250);
    });
  }


  var collectionWaitForJQuery = setInterval(function () {
    if(typeof $ != 'undefined') {
        clearInterval(collectionWaitForJQuery);
        collectionGetVariations();

        $(".filters-toolbar__label[for='Filter'], .filter-bg-shadow, #mobile-filter-menu-close").on("click", function() {
            $(".filters-toolbar__label[for='Filter']").toggleClass("active");
            $(".filters-toolbar__filter-menu-wrapper").toggleClass("show");
            $("body").toggleClass("mobile-overflow-hidden");
        });

        if($(window).width() > 749) {
          $(".page-split-column-left-inner").css({
            height: "calc(100vh - " + $(".sticky-top").height() + "px - " + $(".bottom-info.enable-sticky").height() + "px)" 
          })
        }

        $("[data-left-col-toggle]").click(function() {
          clearProductItemHeight();

          toggleLayout();
          
          setTimeout(function() {
            setProductItemHeight();
          }, 1750);
        });

        $("[data-toggle=page-split--mobile-left-slide-out]").click(function() {
          toggleLayout();
        });

        $("[data-toggle=sort-by-mobile-popout]").click(function() {
          toggleSortBy();
        })

        if($(".description-toggle").length > 0 ) {
          $(".description-toggle").click(function() {
            $(this).parent().toggleClass("show-description");
          })
        }

        setTimeout(function(){
          if($(".product").length > 0) {
            ajaxifyCollection(isSearch);

            productHeightListener();
          }
          else {
            $(".pagination").css("display", "none");
            if($(".no-products").length < 1) {
              if(isSearch === true) {
                // $(".EndlessScroll").append("<div class='grid__item'><div class='no-products'><p>We&#39;re sorry, no products were found for your search: </p></div></div>");
              } else {
                $(".EndlessScroll").append("<div class='grid__item'><div class='no-products'><p>Sorry, there are no products in this collection</p></div></div>");
              }
              
            }
          }
        }, 200);
        
      }
  }, 100);
}